<template>
  <vs-col
    vs-offset=""
    vs-type="flex"
    vs-justify="flex-start"
    vs-align="flex-start"
    vs-w="12"
  >
    <vs-row
      vs-type="flex"
      vs-justify="flex-start"
      vs-align="flex-start"
      vs-w="12"
    >
      <vs-card>
        <div slot="header">
          <vs-row vs-type="flex" vs-justify="flex-start">
            <h6>Path:</h6>
            <h6>&nbsp;{{ this.$route.params.repo_path }}</h6>
          </vs-row>
          <vs-row vs-type="flex" vs-justify="space-between">
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
              vs-w="3.5"
            >
              <vs-button
                @click="back"
                icon-pack="feather"
                icon="icon-arrow-left"
                type="flat"
                size=""
                class="w-full"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="3.5"
            >
              <createsubfolder
                :repo_id="this.$route.params.repo_id"
                :repo_path="this.$route.params.repo_path"
                @addedSubFolder="addedSubFolder($event)"
              />
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="4.5"
            >
              <fileupload
                :repo_id="this.$route.params.repo_id"
                :repo_path="this.$route.params.repo_path"
                @addedFile="addedFile($event)"
              />
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="0.5"
            >
              <vs-tooltip text="Delete" position="bottom">
                <vs-button
                  type="flat"
                  v-if="removeAll"
                  icon-pack="feather"
                  @click="allDelete()"
                  color="danger"
                  icon="icon-trash-2"
                ></vs-button>
                <span></span>
              </vs-tooltip>
            </vs-col>
          </vs-row>
        </div>
        <div>
          <vs-row vs-justify="center" vs-align="center">
            <vs-row type="flex" vs-justify="center"> </vs-row>
            <br />
            <br />

            <vs-col
              vs-offset="0.3"
              type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="2.5"
              :key="index.id"
              v-for="(item, index) in file1"
            >
              <vs-card actionable class="cardx">
                <div slot="media">
                  <img :src="item.file_path" />
                </div>
                <div>
                  <a :href="item.file_path"
                    ><span>{{ item.file_name }}</span></a
                  >

                  <br /><br />
                  <span>{{ item.size }}</span>
                </div>
                <div slot="footer">
                  <vs-row vs-justify="flex-end">
                    <input
                      type="checkbox"
                      class="checkboxStyle"
                      v-model="checkBox1[index]"
                      :value="item.files_id"
                      @click="check($event)"
                    />
                    <vs-tooltip text="Download" position="bottom">
                      <vs-button
                        color="success"
                        type="flat"
                        @click="downloadImage(item)"
                        icon-pack="feather"
                        icon="icon-download"
                      ></vs-button>
                      <span></span>
                    </vs-tooltip>
                    <vs-tooltip text="Delete" position="bottom">
                      <vs-button
                        type="flat"
                        icon-pack="feather"
                        @click="fileDelete(item.files_id)"
                        color="danger"
                        icon="icon-trash-2"
                      ></vs-button>
                      <span></span>
                    </vs-tooltip>
                  </vs-row>
                </div>
              </vs-card>
            </vs-col>
          </vs-row>

          <vs-row vs-justify="center" vs-align="center">
            <vs-row type="flex" vs-justify="center"> </vs-row>
            <br />
            <br />

            <vs-col
              vs-offset="0.3"
              type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="3.4"
              :key="index.id"
              v-for="(item, index) in file2"
            >
              <vs-card>
                <div slot="header">
                  <vs-row vs-type="flex" vs-justify="space-between">
                    <vs-col
                      vs-type="flex"
                      vs-justify="flex-start"
                      vs-align="flex-start"
                      vs-w="8.1"
                    >
                      <h6>
                        <span>
                          <vs-icon
                            icon-pack="feather"
                            icon="icon-folder"
                          ></vs-icon> </span
                        >&nbsp;
                        <router-link
                          :to="{
                            name: 'folder',
                            params: {
                              repo_id: item.repository_id,
                              repo_path: item.repository_path,
                            },
                          }"
                          >{{ item.repository_name }}</router-link
                        >
                      </h6>
                    </vs-col>
                    <vs-col
                      vs-type="flex"
                      vs-justify="flex-end"
                      vs-align="flex-start"
                      vs-w="3.5"
                    >
                      <vs-tooltip text="Delete" position="bottom">
                        <vs-button
                          type="flat"
                          icon-pack="feather"
                          @click="folderDelete(item.repository_id)"
                          color="danger"
                          icon="icon-trash-2"
                        ></vs-button>
                        <span></span>
                      </vs-tooltip>
                    </vs-col>
                  </vs-row>
                </div>
              </vs-card>
            </vs-col>
          </vs-row>
          <br />
          <br />
        </div>
        <div slot="footer"></div>
      </vs-card>

      <vs-popup title="Delete Folder" :active.sync="deletepopupflag">
        <vs-row>
          <span>Are you sure to delete this Folder?</span>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
          <vs-button
            @click="folderDeleteConfirm"
            color="primary"
            type="filled"
            class="mr-2 vs-con-loading__container"
            >Confirm</vs-button
          >
          <vs-button @click="deletepopupflag = !deletepopupflag" type="border"
            >Cancel</vs-button
          >
        </vs-row>
      </vs-popup>
      <vs-popup title="Delete File" :active.sync="deletepopupflag1">
        <vs-row>
          <span>Are you sure to delete this file?</span>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
          <vs-button
            @click="fileDeleteConfirm"
            color="primary"
            type="filled"
            class="mr-2 vs-con-loading__container"
            >Confirm</vs-button
          >
          <vs-button @click="deletepopupflag1 = !deletepopupflag1" type="border"
            >Cancel</vs-button
          >
        </vs-row>
      </vs-popup>
      <vs-popup title="Delete Selected Files" :active.sync="deletepopupflag2">
        <vs-row>
          <span>Are you sure?</span>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
          <vs-button
            @click="allDeleteConfirm"
            color="primary"
            type="filled"
            class="mr-2 vs-con-loading__container"
            >Confirm</vs-button
          >
          <vs-button @click="deletepopupflag2 = !deletepopupflag2" type="border"
            >Cancel</vs-button
          >
        </vs-row>
      </vs-popup>
    </vs-row>
  </vs-col>
</template>

<script>
import sidebar from '@/views/pages/files/index.vue'
import Search from '@/views/pages/files/Search.vue'
import createsubfolder from '@/views/pages/files/CreateSubFolder.vue'
import fileupload from '@/views/pages/files/FileUpload.vue'
import {
  repoDetails,
  fileDelete,
  repoDelete,
  multipleFileDelete
} from '@/api/file.js'
import axios from 'axios'
export default {
  name: 'folders',
  components: {
    sidebar,
    Search,
    createsubfolder,
    fileupload
  },
  // props: {repo_id: Number, repo_path: String},
  data () {
    return {
      checkBox1: [],
      files: [],
      deletedFile: null,
      removeAll: false,
      active: false,
      selectedFile: null,
      deletepopupflag: false,
      deletepopupflag1: false,
      deletepopupflag2: false,
      deleted_id: '',
      file_id: '',
      subfolderData: {
        repository_name: '',
        repository_path: '',
        parent_repository_id: ''
      },
      file1: [],
      file2: []
    }
  },
  mounted () {
    repoDetails(this.$route.params.repo_id)
      .then((res) => {
        this.file2 = res.data.data.repository.sub_repository
        this.file1 = res.data.data.repository.files
        
        
      })
      .catch((e) => {
        
      })
  },
  methods: {
    closeSidebar () {
      this.active = false
    },
    back () {
      // window.history.length > 1 ? this.$router.go(-1) : this.$router.push({name: 'folder'}).catch(() => {})
      this.$router.go(-1)
    },
    fileDelete (id) {
      this.deletepopupflag1 = true
      this.file_id = id
    },
    fileDeleteConfirm () {
      fileDelete(this.file_id)
        .then((res) => {
          
          repoDetails(this.$route.params.repo_id)
            .then((res) => {
              this.file1 = res.data.data.repository.files
              this.deletepopupflag1 = false
              this.$vs.notify({
                title: 'Success',
                text: 'File deleted successfully',
                color: 'success',
                iconPack: 'feather',
                icon: 'icon-alert-circle'
              })
            })
            .catch((e) => {
              
              this.deletepopupflag1 = false
              this.$vs.notify({
                title: 'Warning',
                text: 'Something Went Wrong',
                color: 'warning',
                iconPack: 'feather',
                icon: 'icon-alert-circle'
              })
            })
        })
        .catch((e) => {
          
          this.deletepopupflag1 = false
          this.$vs.notify({
            title: 'Warning',
            text: 'Something Went Wrong',
            color: 'Warning',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        })
    },

    folderDelete (id) {
      this.deletepopupflag = true
      this.deleted_id = id
    },
    folderDeleteConfirm () {
      repoDelete(this.deleted_id)
        .then((res) => {
          
          repoDetails(this.$route.params.repo_id)
            .then((res) => {
              this.file2 = res.data.data.repository.sub_repository
              this.deletepopupflag = false
              this.$vs.notify({
                title: 'Success',
                text: 'Folder deleted successfully',
                color: 'success',
                iconPack: 'feather',
                icon: 'icon-alert-circle'
              })
            })
            .catch((e) => {
              
              this.$vs.notify({
                title: 'Warning',
                text: 'Something Went Wrong',
                color: 'Warning',
                iconPack: 'feather',
                icon: 'icon-alert-circle'
              })
            })
        })
        .catch((e) => {
          
          this.$vs.notify({
            title: 'Warning',
            text: 'Something Went Wrong',
            color: 'Warning',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        })
    },
    addedSubFolder (fetchedData) {
      this.file2 = fetchedData
    },
    addedFile (fetchedData) {
      this.file1 = fetchedData
    },
    downloadImage (item) {
      //
      axios({
        url: `https://cors-anywhere.herokuapp.com/${item.file_path}`,
        method: 'GET',
        responseType: 'blob'
      }).then((response) => {
        const fileUrl = window.URL.createObjectURL(new Blob([response.data]))
        const fileLink = document.createElement('a')
        fileLink.href = fileUrl

        fileLink.setAttribute('download', item.file_name)
        document.body.appendChild(fileLink)

        fileLink.click()
      })
    },
    check (e) {
      if (e.target.checked) {
        this.files.push(e.target.value)
        this.deletedFile = {
          files: this.files
        }
        

        this.removeAll = true
      }
    },
    allDelete () {
      this.deletepopupflag2 = true
    },
    allDeleteConfirm () {
      //
      multipleFileDelete(this.deletedFile)
        .then((res) => {
          
          repoDetails(this.$route.params.repo_id)
            .then((res) => {
              this.file1 = res.data.data.repository.files
              this.checkBox1 = []
              this.removeAll = false
              this.deletepopupflag2 = false
              this.$vs.notify({
                title: 'Success',
                text: 'Files deleted successfully',
                color: 'success',
                iconPack: 'feather',
                icon: 'icon-alert-circle'
              })
            })
            .catch((e) => {
              
              this.checkBox1 = []
              this.removeAll = false
              this.deletepopupflag2 = false
              this.$vs.notify({
                title: 'Warning',
                text: 'Something Went Wrong',
                color: 'Warning',
                iconPack: 'feather',
                icon: 'icon-alert-circle'
              })
            })
        })
        .catch((e) => {
          
          this.checkBox1 = []
          this.removeAll = false
          this.deletepopupflag2 = false
          this.$vs.notify({
            title: 'Warning',
            text: 'Something Went Wrong',
            color: 'Warning',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        })
    }
  }
}
</script>
<style lang="stylus">
.vs-sidebar-position-right {
  width: 375px !important;
  max-width: 400px !important;
  z-index: 111111111111111 !important;
  /* height: auto !important; */
  /* position: absolute; */
  /* top: 12%; */
}

// [dir] .vs-content-sidebar.items-no-padding .vs-sidebar--items {
//   overflow-y: scroll;
// }

.select_custom {
  height: 40px;
  border: none;
  background-color: white;
  border: 1px solid #cccccc;
  color: #787878;
  font-size: 14px;
  width: 100%;
  border-radius: 5px;
}

.header-sidebar-style {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;

  h4 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    > button {
      margin-left: 10px;
    }
  }
}

.footer-sidebar-style {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  > button {
    border: 0px solid rgba(0, 0, 0, 0) !important;
    border-left: 1px solid rgba(0, 0, 0, 0.07) !important;
    border-right: 1px solid rgba(0, 0, 0, 0.07) !important;
  }
}

.inputField {
  height: 44px;
  border: none;
  background-color: white;
  color: #787878;
  font-size: 12px;
  width: 100%;
  border-bottom: 2px dotted #cccccc;
}

.checkboxStyle {
  cursor: pointer;
  margin-top: 13px;
  margin-right: 12px;
}
</style>